import * as React from "react";
import "./AuthorizationInfoSummary.scss";
import { AuthorizationInfo } from "./AuthorizationInfo";
import AuthorizationInformationItemsList from "../patient-management/AuthorizationInformationItemsList";
import EditAction from "../commons/components/action/EditAction";

export default function AuthorizationInfoSummary({
  forMyself,
  authorizationInfo,
  editAction,
  showEditAuthorizationForm,
}: {
  forMyself: boolean;
  authorizationInfo: AuthorizationInfo;
  editAction: boolean;
  showEditAuthorizationForm: () => any;
}) {
  return (
    <div className="authorizations-info-summary">
      <div className="panel-title h-flex space-between no-wrap">
        <div>{i18n["Page.Portal.AuthorizationInformation.Title"]}</div>
        {editAction && authorizationInfo && <EditAction onClick={showEditAuthorizationForm} />}
      </div>
      <div>
        {editAction && authorizationInfo ? (
          authorizationInfo.hasAuthorization ? (
            <AuthorizationInformationItemsList authorizationInfo={authorizationInfo} />
          ) : (
            <div>
              <span>{i18n["Page.Portal.AuthorizationInformation.DontAuthorized"]}</span>
            </div>
          )
        ) : (
          <div className={"h-flex centered action-container"}>
            <button className="button-secondary small" onClick={showEditAuthorizationForm}>
              {
                i18n[
                  forMyself
                    ? "Page.Portal.AuthorizationInformation.CompleteInformation.ForMyself.Button"
                    : "Page.Portal.AuthorizationInformation.CompleteInformation.Button"
                ]
              }
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
